import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PpbApiService } from '../shared/services/ppb-api.service';
import { ActivationLinkResponse } from './account-activation.model';

@Injectable()
export class AccountActivationService {

  constructor(private api: PpbApiService) {
  }

  accountActivationStart(activationCode: string): Observable<ActivationLinkResponse> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.api.getPublic<ActivationLinkResponse>(
      '/auth-api/v1/public/account/link/activate/' + activationCode,
      new HttpParams(),
      headers
    );
  }

  accountActivationPassword(passwordUuid: string): Observable<{ token: string }> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = {};

    return this.api.postPublic<{ token: string }>(
      '/auth-api/v1/public/account/link/activate/sms/' + passwordUuid,
      body,
      new HttpParams(),
      headers
    )
  }

  accountActivationSms(
    smsUuid: string,
    smsCode: string,
    privacyPolicyAgreement: boolean,
    rulesAgreement: boolean
  ): Observable<{ token: string }> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = {
      'privacyPolicyAgreement': privacyPolicyAgreement,
      'rulesAgreement': rulesAgreement,
      smsCode
    };

    return this.api.postPublic<{ token: string }>(
      '/auth-api/v1/public/account/link/activate/activate/' + smsUuid,
      body,
      new HttpParams(),
      headers
    ).pipe(
      catchError(_ => EMPTY)
    );
  }
}
